import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { Icon } from "@iconify/react";
import axios from "axios";

const baseUrl = process.env.REACT_APP_API;

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const checkPasswordStrength = (password) => {
    if (password.length < 6) return "Weak";
    if (password.match(/[A-Z]/) && password.match(/[0-9]/) && password.length >= 8) return "Strong";
    return "Medium";
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Extract token from the query string (without key)
    const token = window.location.search?.substring(1); // gets the part after '?' directly
  
    if (!password || !confirmPassword) {
      toast.error("Please fill in both fields.");
      return;
    }
  
    if (!token) {
      toast.error("Token not found in the URL.");
      return;
    }
  
    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
  
    const strength = checkPasswordStrength(password);
    if (strength === "Weak") {
      toast.error("Password is too weak.");
      return;
    }
  
    try {
      const response = await axios.post(`${baseUrl}/auth/verify_forgotpassword`, {
        token,
        newPassword: password
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        toast.success("Password reset successful!");
        navigate("/token/signin");
      } else {
        toast.error(response.data?.message || "Something went wrong.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong. Try again.");
    }
  };
  
  

  return (
    <>
      <div
        style={{
          backgroundImage: `url(/images/main-background.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          width: "100%",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: -1,
          filter: "blur(10px)",
        }}
      ></div>
      <div className="bg-overlay"></div>

      <div className="auth-container" style={{ marginTop: '80px' }}>
        <div className="auth-wrapper">
          <div className="auth-card">
            <h1 className="auth-title">Set a New Password</h1>
            <p className="auth-subtitle">Enter your new password below</p>

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group password-container">
                <Icon icon="mdi:lock" className="input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-input"
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Icon icon={showPassword ? "mdi:eye-off" : "mdi:eye"} />
                </span>
                {/* <p className="password-strength">
                  Strength: {checkPasswordStrength(password)}
                </p> */}
              </div>

              <div className="form-group password-container">
                <Icon icon="mdi:lock-check" className="input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-input"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>

              <button type="submit" className="submit-button">
                Reset Password
              </button>

              <div className="back-to-login">
                <button
                  type="button"
                  className="forgot-password-btn"
                  onClick={() => navigate("/token/signin")}
                >
                  Back to Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style jsx>{`
        .auth-container {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
        }
        
        .auth-wrapper {
          width: 100%;
          max-width: 500px;
        }
        
        .auth-card {
          border-radius: 16px;
          padding: 30px;
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
          backdrop-filter: blur(5px);
          -webkit-backdrop-filter: blur(5px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        
        .auth-title {
          font-size: 2rem;
          color: #333;
          text-align: center;
          margin-bottom: 10px;
        }
        
        .auth-subtitle {
          color: #666;
          text-align: center;
          margin-bottom: 30px;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .input-with-icon {
          position: relative;
        }
        
        .input-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: #666;
          font-size: 1.2rem;
        }
        
        .form-input {
          width: 100%;
          padding: 15px 15px 15px 45px;
          border-radius: 8px;
          border: 1px solid #ddd;
          font-size: 1rem;
          box-sizing: border-box;
        }
        
        .password-container {
          position: relative;
        }
        
        .password-toggle {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          color: #666;
        }
        
        .forgot-password, .back-to-login {
          text-align: center;
          margin: 20px 0;
        }
        
        .forgot-password-btn {
          background: none;
          border: none;
          color: #f0b90b;
          cursor: pointer;
          font-size: 0.9rem;
          padding: 0;
        }
        
        .forgot-password-btn:hover {
          text-decoration: underline;
        }
        
        .submit-button {
          width: 100%;
          padding: 15px;
          border-radius: 8px;
          border: none;
          background-color: #f0b90b;
          color: white;
          font-size: 1rem;
          cursor: pointer;
          transition: background-color 0.3s;
        }
        
        .submit-button:hover {
          background-color: #e0a800;
        }
        
        .submit-button:disabled {
          background-color: #6c757d;
          cursor: not-allowed;
        }
        
        .auth-redirect {
          text-align: center;
          margin-top: 20px;
          color: #666;
        }
        
        .redirect-link {
          color: #f0b90b;
          text-decoration: none;
          font-weight: 600;
        }
        
        .redirect-link:hover {
          text-decoration: underline;
        }
        
        .error-message {
          color: #dc3545;
          font-size: 0.8rem;
          margin-top: 5px;
        }
        
        @media (max-width: 768px) {
          .auth-card {
            padding: 20px;
          }
          
          .input-icon {
            display:none;
          }
          
          .auth-title {
            font-size: 1.5rem;
          }
          
          .form-input {
            padding: 12px 12px 12px 40px;
          }
        }
        
        @media (max-width: 480px) {
          .auth-container {
            padding: 10px;
            margin-top: 60px;
          }

          .input-icon {
            display:none;
          }
          
          .auth-card {
            padding: 15px;
          }
          
          .auth-title {
            font-size: 1.3rem;
          }
          
          .auth-subtitle {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </>
  );
}
